$shm_hitalama_components_drafts $mol_book2
	model $shm_hitalama_components_drafts_model
	selected? \
	editing? false
	pages <= draft_pages /$mol_view
	List $shm_hitalama_components_drafts_list
		model <= model
		selected? <=> selected?
		created? <=> created? null
		opened? <=> opened? null
	Preview $shm_hitalama_components_drafts_preview
		model <= model
		selected <= selected?
		editing? <=> editing?
		close? <=> close? null
	Editor $shm_hitalama_components_drafts_editor
		model <= model
		selected <= selected?
		editing? <=> editing?
		removed? <=> close? null
